import React from 'react'
import { Controller } from 'react-hook-form'
import { FormFeedback, Input, Label } from 'reactstrap'

const InputEmail = ({
  label,
  options,
  control,
  errors,
}) => {

  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        control={control}
        render={({ field }) => (
          <Input
            invalid={errors[options.name] && true}
            {...field}
            placeholder=""
            className='form-control'
            type="text"
            disabled={options?.disabled}
            onChange={(e) => {
              const valueWithoutSpaces = e.target.value.replace(/\s/g, '')
                field.onChange({
                  ...e,
                  target: {
                    ...e.target,
                    value: valueWithoutSpaces
                  }
                })
            }}
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
    </React.Fragment>
  )
}

export default InputEmail